import { User } from "@/entities";
import { ProfilePicture } from "@/entities/user";

/**
 *
 * Data Transfer Object for the user entity.
 */
export interface UserDTO {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  entity_id: number | null;
  role_id: number;
  created_at: string;
  updated_at: string;
  enabled: number;
  email_verified_at: string | null;
  profile_picture?: ProfilePicture;
  full_name?: string;
}

/**
 * Converts an UserDTO to User entity
 * @param dto - The userDTO
 * @returns The User entity.
 */
export function userFromDTO(dto: UserDTO): User {
  return {
    id: dto.id,
    firstName: dto.first_name,
    email: dto.email,
    lastName: dto.last_name,
    entityId: dto.entity_id,
    createdAt: new Date(Date.parse(dto.created_at)),
    updatedAt: new Date(Date.parse(dto.updated_at)),
    roleId: dto.role_id,
    enabled: !!dto.enabled,
    emailVerifiedAt: dto.email_verified_at,
    profilePicture: dto.profile_picture,
    full_name: dto.full_name,
  };
}
